import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6ec6bcbb&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6ec6bcbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6bcbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec6bcbb')) {
      api.createRecord('6ec6bcbb', component.options)
    } else {
      api.reload('6ec6bcbb', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6ec6bcbb&scoped=true&", function () {
      api.rerender('6ec6bcbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2W4M5RXCkfo4c/JS/comp/GuestBox.vue"
export default component.exports